import PropTypes from 'prop-types';
// next
import { useRouter } from 'next/router'
// @mui
import { styled, alpha } from '@mui/material/styles';
import { List, Box, ListSubheader, Stack, Typography, Chip, Divider } from '@mui/material';
// components
import { NavListRoot } from './NavList';
import { CrewItem } from './CrewItem';
import Iconify from '../../../components/Iconify';
// paths
import { PATH_CREWS } from '../../../routes/paths';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

export default function NavSectionVertical({ navConfig, crews = [], isCollapse = false }) {
  const router = useRouter();
  return (
    <Box>
      {navConfig.map((group, index) => (
        <List
          key={group.subheader}
          disablePadding
          sx={{ px: 2 }}
        >
          {group.items.map((list) => (
            <NavListRoot key={list.title} list={list} isCollapse={isCollapse} />
          ))}
          {index === 0 && (
            <Divider sx={{ my: 1 }} />
          )}
        </List>
      ))}
      {crews.map((group) => (
        <List key={group.header?.title} disablePadding sx={{ px: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              mt: 1,
              paddingTop: 3,
              paddingLeft: 2,
              paddingRight: 1,
              paddingBottom: 1,
            }}
          >
            <Stack direction="row" alignItems="center">
              <ListSubheaderStyle
                sx={{
                  ...(isCollapse && {
                    opacity: 0,
                  }),
                }}
              >
                {group.header?.title}
              </ListSubheaderStyle>
              <Chip
                label={group.items?.length}
                size="small"
                sx={{
                  ml: 1,
                  color: 'grey.800',
                  bgcolor: 'grey.300',
                  fontWeight: 'bold',
                }}
              />
            </Stack>
            <Stack direction="row" alignItems="center"
              sx={{
                px: 1,
                py: 0.5,
                '&:hover': {
                  cursor: 'pointer',
                  backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                  borderRadius: 1,
                },
                '&:active': {
                  backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.16),
                }
              }}
              onClick={() => router.push(PATH_CREWS.root)}
            >
              <Typography variant="overline" color="text.secondary">
                전체보기
              </Typography>
              <Iconify
                icon={'eva:chevron-right-fill'}
                sx={{
                  color: "text.secondary",
                  ml: 0.5,
                  width: 20,
                  height: 20,
                }}
              />
            </Stack>
          </Stack>
          <Stack spacing={1} sx={{ mt: 0.5, pb: 2 }}>
          {group.items.map((crew) => (
            <CrewItem key={crew.id} crew={crew} />
          ))}
          </Stack>
        </List>
      ))}
    </Box>
  );
}
